export const footerMoreLinks = {
  'gb-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.co.uk/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.co.uk/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.co.uk/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.co.uk/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.co.uk/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.co.uk/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'gb-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.co.uk/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.co.uk/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.co.uk/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.co.uk/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.co.uk/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.co.uk/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'gb-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.co.uk/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.co.uk/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.co.uk/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.co.uk/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.co.uk/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.co.uk/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'gb-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.co.uk/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.co.uk/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.co.uk/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.co.uk/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.co.uk/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.co.uk/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'gb-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.co.uk/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.co.uk/ar/faq/',
          title: 'الأسئلة المتكررة',
        },

        {
          href: 'https://www.wingie.co.uk/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.co.uk/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.co.uk/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.co.uk/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'gb-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.co.uk/it/contact/', title: 'Contatto' },
        // { href: 'https://www.wingie.co.uk/it/faq/', title: 'Domande frequenti' },

        { href: 'https://www.wingie.co.uk/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.co.uk/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.co.uk/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.co.uk/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'gb-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.co.uk/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.uk/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://www.wingie.co.uk/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.co.uk/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.co.uk/fr/terms-and-conditions/', title: 'Termes et conditions' },
        { href: 'https://www.wingie.co.uk/fr/awards/', title: 'Nos récompenses' },
      ],
    },
  ],
  'gb-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.co.uk/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.co.uk/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://www.wingie.co.uk/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.co.uk/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.co.uk/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.co.uk/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'gb-ro': [
    {
      title: 'Mai multe',
      items: [
        { href: 'https://www.wingie.co.uk/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.uk/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://www.wingie.co.uk/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.co.uk/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.co.uk/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.co.uk/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'gb-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.co.uk/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.co.uk/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://www.wingie.co.uk/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.co.uk/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.co.uk/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.co.uk/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'gb-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.co.uk/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.co.uk/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://www.wingie.co.uk/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.co.uk/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.co.uk/lt/terms-and-conditions/', title: 'Sąlygos' },
        { href: 'https://www.wingie.co.uk/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'gb-uz': [
    {
      title: 'Boshqa',
      items: [
        { href: 'https://www.wingie.co.uk/uz/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.co.uk/uz/faq/', title: "Ko'p beriladigan savollar" },

        { href: 'https://www.wingie.co.uk/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.co.uk/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.co.uk/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.co.uk/uz/awards/', title: 'Bizning mukofotlar' },
      ],
    },
  ],
  'gb-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.co.uk/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.co.uk/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://www.wingie.co.uk/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.co.uk/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.co.uk/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.co.uk/sr/awards/', title: 'Наше награде' },
      ],
    },
  ],
  'gb-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.co.uk/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.co.uk/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://www.wingie.co.uk/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.co.uk/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.co.uk/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.co.uk/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'gb-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.co.uk/tg/contact/', title: 'Тамос' },
        // { href: 'https://www.wingie.co.uk/tg/privacy/', title: 'Саволҳои зиёд додашаванда' },

        { href: 'https://www.wingie.co.uk/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.co.uk/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.co.uk/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.co.uk/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'gb-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.co.uk/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.co.uk/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://www.wingie.co.uk/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.co.uk/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://www.wingie.co.uk/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.co.uk/kk/awards/', title: 'Біздің марапаттар' },
      ],
    },
  ],
  'gb-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.co.uk/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.co.uk/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://www.wingie.co.uk/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.co.uk/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.co.uk/nl/terms-and-conditions/', title: 'Voorwaarden' },
        { href: 'https://www.wingie.co.uk/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'gb-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.co.uk/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.co.uk/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.co.uk/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.co.uk/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.co.uk/ja/awards/' },
      ],
    },
  ],
  'gb-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.co.uk/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.co.uk/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.co.uk/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.co.uk/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.co.uk/zh/awards/' },
      ],
    },
  ],
  'gb-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.co.uk/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.co.uk/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.co.uk/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.co.uk/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.co.uk/ko/awards/' },
      ],
    },
  ],
  'gb-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.co.uk/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.co.uk/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.co.uk/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.co.uk/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.co.uk/hi/awards/' },
      ],
    },
  ],
  'gb-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.co.uk/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.co.uk/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.co.uk/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.co.uk/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.co.uk/ta/awards/' },
      ],
    },
  ],
  'gb-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.co.uk/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.co.uk/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.co.uk/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.co.uk/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.co.uk/th/awards/' },
      ],
    },
  ],
  'gb-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.co.uk/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.co.uk/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.co.uk/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.co.uk/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.co.uk/ur/awards/' },
      ],
    },
  ],
  'gb-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.co.uk/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.co.uk/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.co.uk/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.co.uk/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.co.uk/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.co.uk/ka/awards/' },
      ],
    },
  ],
}
